import React, { Component } from "react";
import { Formik, Form } from "formik";
import Dialog from "../UI/Dialog";
import RadioGroup from "../UI/Radio-f";
import DatePickerUI from "../UI/DatePicker-f";

class DeactivateDialog extends Component {
  render() {
    return (
      <Dialog open={this.props.open} handleClose={this.props.close}>
        <Formik
          initialValues={{
            deactivate: "deactivate_from_now"
          }}
          onSubmit={this.props.onSubmitDialog}
          render={({
            values,
            touched,
            setFieldValue,
            onChange,
            handleChange,
            handleBlur,
            errors,
            dirty
          }) => (
            <Form>
              <div className="py-30 px-20">
                <div className="flex align-end">
                  <div className="col-xs-7">
                    <RadioGroup
                      MenuItemRadio
                      onChange={handleChange}
                      name="deactivate"
                      value={values.deactivate}
                      labelFirst="Deactivate starting from now"
                      valueFirst="deactivate_from_now"
                      labelSecond="Deactivate starting from"
                      valueSecond="deactivate_from"
                    />
                  </div>
                  <div className="col-xs-5">
                    <DatePickerUI
                      label="From"
                      disabled={values.deactivate === "deactivate_from_now"}
                      name="date"
                      value={values.date}
                      onChange={setFieldValue}
                    />
                  </div>
                </div>
              </div>
              <div className="popup-meta flex justify-end">
                <button
                  className="no-style w-600 pointer mx-20"
                  type="button"
                  onClick={this.props.close}
                >
                  Cancel
                </button>
                <button type="submit" className="btn filled primary min-120">
                  Save
                </button>
              </div>
            </Form>
          )}
        />
        <button className="no-style close-btn" onClick={this.props.close}>
          ×
        </button>
      </Dialog>
    );
  }
}

export default DeactivateDialog;



// WEBPACK FOOTER //
// ./src/components/Customer-web-portal/DeactivateDialog.js